import { type InsuranceCorporateIdentity } from "../types";

export function WMFLogo({ className }: { className?: string }) {
  return (
    <svg
      width="512"
      height="512"
      viewBox="0 0 512 512"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <defs>
        <clipPath id="clip0_30_1419">
          <rect
            width="432"
            height="225"
            fill="white"
            transform="translate(41 155)"
          />
        </clipPath>
      </defs>
      <g clipPath="url(#clip0_30_1419)">
        <path
          d="M208.978 273.073V319.404C208.996 321.33 208.225 323.178 206.852 324.53C204.034 327.394 199.418 327.438 196.548 324.627L196.45 324.53C195.077 323.178 194.306 321.33 194.324 319.404V287.258L181.131 321.375C180.529 322.93 179.474 324.274 178.101 325.228C175.248 327.19 171.482 327.208 168.603 325.281C167.212 324.371 166.158 323.036 165.573 321.481L152.283 287.939V319.669C152.283 323.549 149.128 326.695 145.239 326.695C141.349 326.695 138.195 323.549 138.195 319.669V273.073C138.142 270.129 139.311 267.301 141.438 265.268C145.354 261.565 151.308 261.026 155.827 263.969C157.608 265.295 158.954 267.116 159.707 269.201L173.618 305.678L187.475 269.201C188.21 267.124 189.539 265.304 191.302 263.969C193.225 262.643 195.529 261.98 197.868 262.086C203.964 262.086 208.925 266.992 208.987 273.081"
          fill="white"
        />
        <path
          d="M127.793 271.632L112.953 319.739C112.315 321.737 111.066 323.496 109.391 324.76C107.69 326.05 105.599 326.731 103.464 326.695C101.275 326.731 99.1399 326.024 97.4033 324.698C95.6667 323.407 94.4352 321.56 93.8947 319.465L84.5828 286.657L75.2442 319.554C74.6595 321.587 73.4279 323.381 71.7356 324.654C68.2713 327.34 63.4337 327.385 59.9251 324.76C58.2329 323.505 56.9925 321.746 56.3634 319.739L41.5936 271.817C41.124 270.306 41.1418 268.68 41.6468 267.177C42.1252 265.675 43.0733 264.367 44.358 263.456C45.6604 262.528 47.2286 262.051 48.8235 262.077C50.4714 262.06 52.084 262.599 53.3953 263.589C54.7243 264.579 55.6989 265.975 56.1596 267.575L66.2867 303.866L75.3328 269.378C75.8201 267.274 77.034 265.401 78.7617 264.093C80.516 262.74 82.6867 262.033 84.9017 262.077C87.0902 262.042 89.2343 262.758 90.962 264.093C92.6897 265.401 93.9036 267.266 94.3909 269.378L103.437 303.786L113.573 267.495C113.989 265.949 114.902 264.579 116.178 263.589C118.792 261.627 122.371 261.565 125.056 263.421C126.305 264.314 127.235 265.578 127.714 267.036C128.219 268.521 128.245 270.129 127.767 271.632"
          fill="white"
        />
        <path
          d="M224.616 264.11C226.238 262.634 228.4 261.892 230.588 262.033H262.05C265.639 262.033 268.554 264.915 268.562 268.485V268.53C268.607 270.289 267.916 271.985 266.657 273.223C265.453 274.46 263.778 275.15 262.05 275.114H238.358V289.282H259.516C263.016 289.335 265.807 292.217 265.745 295.708C265.692 299.119 262.927 301.868 259.516 301.921H238.358V318.078C238.394 320.164 237.561 322.179 236.055 323.628C234.566 325.14 232.528 325.979 230.402 325.926C226.061 325.926 222.534 322.409 222.534 318.078V270.059C222.393 267.876 223.137 265.719 224.616 264.102"
          fill="white"
        />
        {/* Additional paths for the rest of the logo */}
        <path
          d="M352.122 174.091C353.061 185.537 344.529 195.577 333.055 196.514C321.581 197.451 311.516 188.94 310.577 177.494C309.638 166.048 318.17 156.008 329.644 155.071C341.118 154.134 351.183 162.654 352.122 174.1"
          fill="#FCEA10"
        />
        <path
          d="M183.709 239.531C170.8 239.531 156.163 235.598 139.453 224.444C132.587 219.839 130.762 210.558 135.369 203.709C139.967 196.876 149.235 195.047 156.101 199.599C181.459 216.533 195.396 209.135 214.693 198.883C226.716 192.501 240.325 185.272 256.911 185.121C274.197 184.892 288.037 192.263 300.379 198.759C319.915 209.056 334.038 216.498 360.459 199.342C367.397 194.844 376.673 196.806 381.183 203.726C385.693 210.647 383.726 219.901 376.788 224.399C335.624 251.136 307.166 236.146 286.398 225.195C276.049 219.733 267.074 215.004 257.647 215.004H257.257C247.927 215.084 239.049 219.803 228.763 225.265C216.651 231.7 201.917 239.522 183.718 239.522"
          fill="#1AB8D1"
        />
      </g>
    </svg>
  );
}

export const WMF: InsuranceCorporateIdentity = {
  id: "wmf",
  name: "WMF BKK",
  logo: WMFLogo,
  backgroundColor: "#F00551",
  textColor: "#FFFFFF",
  wildcard: "wmf bkk",
  type: "statutory",
};
